import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CostCenterForm from '../components/CostCenterForm'

import { useCostCenter } from '@/features/costCenters/useCostCenter'
import { LoadingSection } from '@/components/Elements'

const EditCostCenterPage = () => {
  const { id } = useParams()

  const { useFetchCostCenter, useUpdateCostCenter } = useCostCenter()

  const updateCostCenter = useUpdateCostCenter()
  const navigate = useNavigate()

  const { data: costCenter, isLoading } = useFetchCostCenter(id)

  const onSubmit = async (data) => {
    // console.log('In Edit CostCenter Page: ', data)
    updateCostCenter.mutate(
      { id, data },
      {
        onSuccess: () => {
          navigate('/admin/costCenters')
        },
      }
    )
  }

  if (isLoading || !costCenter) {
    return <LoadingSection />
  }

  return <CostCenterForm onSubmitAction={onSubmit} costCenter={costCenter} />
}

export default EditCostCenterPage
